import { createAction, props } from '@ngrx/store';
import { RetirementInfo } from '@redux/reducers/retirement-info.reducer';

export const fullUpdateRetirementInfo = createAction(
  '[Retirement Info] Full update',
  props<{ newretirementInfo: RetirementInfo }>()
);
